import React from 'react'
import { graphql } from 'gatsby'

import Layout from '../components/layout'
import Billboard from '../components/Billboard'

import Seo from '../components/seo'
import WhitePapersList from "../components/pages/white-papers/WhitePapersList/WhitePapersList";

const WhitepapersPage = ({ data }) => {
    const whitePapers = data.allFile.edges

    return (
        <Layout>
            <Seo
                title="Whitepapers"
                description="Cloudnexa's Whitepapers."
            />

            <Billboard className="Billboard--resources" color="white">
                <div className="Billboard__top">
                    <h1 className="Billboard__title">Whitepapers</h1>
                    <div className="Billboard__lead">
                        Insights from the AWS Experts at Cloudnexa
                    </div>

                    <div className="Billboard__cta" />
                </div>
            </Billboard>

            <WhitePapersList whitePapers={whitePapers} />
        </Layout>
    )
}

export const query = graphql`
  {
        allFile(
          filter: {
            internal: {mediaType: {eq: "text/markdown"}}, 
            sourceInstanceName: {eq: "white-papers"}
          }
        ) {
          edges {
            node {    
              id              
              childMarkdownRemark {
                id
                frontmatter {
                    slug
                    title
                    featuredImage
                    author
                    createdAt(formatString: "LL")
                }
              }
            }
          }
        }  
  }  
`

export default WhitepapersPage
